<template>
  <div id="Users">
    <MyBanner
      :text="$t('banner.accessDcPage')"
      v-if="$t('banner.accessDcPage') !== ''"
    />
    <MyHeaderPage
      :title="$t('reports.cloud.title')"
      :subtitle="$t('reports.cloud.subTitle')"
    />
    <br /><br />
    <div class="mdl-tabs mdl-js-tabs mdl-js-ripple-effect">
      <div class="mdl-tabs__tab-bar">
        <span
          class="mdl-tabs__tab tabOne is-active"
          id="tabOne"
          @click="setTab(1)"
        >
          Cloud
          <div class="line"></div>
        </span>
        <span
          class="mdl-tabs__tab tabTwo vcloud-wide-tab"
          id="tabTwo"
          @click="setTab(2)"
        >
          VCloud Director
          <div class="line"></div>
        </span>
      </div>

      <div class="mdl-tabs__panel tabOne is-active">
        <div id="TicketsList">
          <div class="listTicket">
            <!-- FILTRO -->
            <div class="mdl-grid">
              <!-- Search Input (smaller width: e.g., 3 columns) -->
              <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
                <div class="filterTickets">
                  <div class="contentInputFilter">
                    <div class="contentIcon">
                      <span class="material-icons">search</span>
                    </div>
                    <div class="contentInput">
                      <input
                        type="text"
                        :placeholder="$t('actions.text_search_placeholder')"
                        v-model="searchString"
                        @keyup="searchByString"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <!-- Date From (3 columns) -->
              <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
                <div class="cdl-input" style="margin-top: 0">
                  <input
                    type="date"
                    name="dateFrom"
                    class="not-empty"
                    v-model="dateFrom"
                    style="background-color: white"
                    @change="handleDateChange()"
                  />
                  <label>{{ $t("reports.filter.dateFrom") }}</label>
                  <span
                    class="error"
                    v-if="v$.dateFrom.$invalid && v$.dateFrom.$dirty"
                  >
                    {{ $t("reports.filter.dateFrom") }}
                    {{ $t("reports.filter.isRequired") }}
                  </span>
                </div>
              </div>

              <!-- Date To (3 columns) -->
              <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
                <div class="cdl-input" style="margin-top: 0">
                  <input
                    type="date"
                    name="dateTo"
                    class="not-empty"
                    v-model="dateTo"
                    style="background-color: white"
                    @change="handleDateChange()"
                  />
                  <label>{{ $t("reports.filter.dateTo") }}</label>
                  <span
                    class="error"
                    v-if="v$.dateTo.$invalid && v$.dateTo.$dirty"
                  >
                    {{ $t("reports.filter.dateTo") }}
                    {{ $t("reports.filter.isRequired") }}
                  </span>
                </div>
              </div>

              <!-- Dropdown for Project Filter (3 columns) -->
              <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
                <div class="cdl-input" style="margin-top: 0">
                  <select
                    v-model="selectedProject"
                    @change="filterByProject"
                    style="background-color: white"
                  >
                    <option value="">{{ $t("reports.filter.all") }}</option>
                    <option
                      v-for="(project, index) in uniqueProjects"
                      :key="index"
                      :value="project"
                    >
                      {{ project }}
                    </option>
                  </select>
                </div>
              </div>
              <!-- CSV Export Button -->
              <div
                class="mdl-cell mdl-cell--2-col mdl-cell--10-offset mdl-cell--12-col-tablet mdl-cell--12-col-phone"
              >
                <ActionButton
                  custom-class="cdlButton"
                  :loading="isExporting"
                  :disabled="!viewLoader"
                  @click="exportCsvCloud"
                >
                  <img src="@/assets/img/download.png" alt="icon" />
                  {{ $t("users.downLoadCSV") }}
                </ActionButton>
              </div>
            </div>
            <!-- FINE FILTRO -->
            <div class="mdl-grid">
              <div class="mdl-cell mdl-cell--12-col">
                <br />
                <p class="default-range-notice">
                  {{ $t("reports.cloud.defaultRangeNotice") }}
                </p>
                <ReportTable
                  :items="pagedItems"
                  :loading="viewLoader"
                  :empty-colspan="$IsMobile() ? 1 : 6"
                  table-class="cloud-report-table"
                >
                  <template #header>
                    <tr v-if="!$IsMobile()">
                      <th class="col-date">
                        {{ $t("reports.cloud.col.colOne") }}
                      </th>
                      <th class="col-description">
                        {{ $t("reports.cloud.col.colTwo") }}
                      </th>
                      <th class="col-hours">
                        {{ $t("reports.cloud.col.colThree") }}
                      </th>
                      <th class="col-pph">
                        {{ $t("reports.cloud.col.colFour") }}
                      </th>
                      <th class="col-charge">
                        {{ $t("reports.cloud.col.colFive") }}
                      </th>
                      <th class="col-project">
                        {{ $t("reports.cloud.col.colSix") }}
                      </th>
                    </tr>
                  </template>

                  <template #row="{ item, index }">
                    <tr :class="{ odd: index % 2 }">
                      <td class="col-date">{{ item.data_charge }}</td>
                      <td class="col-description">{{ item.description }}</td>
                      <td class="col-hours">{{ item.usage_hours }}</td>
                      <td class="col-pph">{{ item.usage_pph }}</td>
                      <td class="col-charge">{{ item.usage_charge }}</td>
                      <td class="col-project">{{ item.project_name }}</td>
                    </tr>
                  </template>

                  <template #mobile="{ item, index }">
                    <tr :class="{ odd: index % 2 }">
                      <td>
                        <div>
                          <strong>{{ $t("reports.cloud.col.colOne") }}</strong>
                        </div>
                        <div>{{ item.data_charge }}</div>
                        <br />
                        <div>
                          <strong>{{ $t("reports.cloud.col.colTwo") }}</strong>
                        </div>
                        <div>{{ item.description }}</div>
                        <br />
                        <div>
                          <strong>{{
                            $t("reports.cloud.col.colThree")
                          }}</strong>
                        </div>
                        <div>{{ item.usage_hours }}</div>
                        <br />
                        <div>
                          <strong>{{ $t("reports.cloud.col.colFour") }}</strong>
                        </div>
                        <div>{{ item.usage_pph }}</div>
                        <br />
                        <div>
                          <strong>{{ $t("reports.cloud.col.colFive") }}</strong>
                        </div>
                        <div>{{ item.usage_charge }}</div>
                        <br />
                        <div>
                          <strong>{{ $t("reports.cloud.col.colSix") }}</strong>
                        </div>
                        <div>{{ item.project_name }}</div>
                      </td>
                    </tr>
                  </template>
                </ReportTable>
                <Paginator
                  v-if="viewLoader && totalItems > 0"
                  :total-page="paginatedItems"
                  :current-page="currentPage"
                  :itemsPerPage="itemsPerPage"
                  @prev-page="beforePage"
                  @next-page="nextPage"
                  @change-page="changePage"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mdl-tabs__panel tabTwo">
        <div id="VCloudList">
          <div class="listTicket">
            <!-- FILTERS VCloud -->
            <div class="mdl-grid">
              <!-- Search Input -->
              <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
                <div class="filterTickets">
                  <div class="contentInputFilter">
                    <div class="contentIcon">
                      <span class="material-icons">search</span>
                    </div>
                    <div class="contentInput">
                      <input
                        type="text"
                        :placeholder="$t('actions.text_search_placeholder')"
                        v-model="vSearchString"
                        @keyup="searchVByString"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <!-- Date From -->
              <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
                <div class="cdl-input" style="margin-top: 0">
                  <input
                    type="date"
                    name="vDateFrom"
                    class="not-empty"
                    v-model="vDateFrom"
                    style="background-color: white"
                    @change="getVcloudList()"
                  />
                  <label>{{ $t("reports.filter.dateFrom") }}</label>
                </div>
              </div>

              <!-- Date To -->
              <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
                <div class="cdl-input" style="margin-top: 0">
                  <input
                    type="date"
                    name="vDateTo"
                    class="not-empty"
                    v-model="vDateTo"
                    style="background-color: white"
                    @change="getVcloudList()"
                  />
                  <label>{{ $t("reports.filter.dateTo") }}</label>
                </div>
              </div>

              <!-- Dropdown for Project Filter -->
              <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
                <div class="cdl-input" style="margin-top: 0">
                  <select
                    v-model="vSelectedProject"
                    @change="filterByVProject"
                    style="background-color: white"
                  >
                    <option
                      v-for="(project, index) in vUniqueProjects"
                      :key="index"
                      :value="
                        typeof project === 'object' && project !== null
                          ? project.name
                          : project
                      "
                    >
                      {{
                        typeof project === "object" && project !== null
                          ? project.label
                          : project
                      }}
                    </option>
                  </select>
                </div>
              </div>

              <!-- CSV Export Button -->
              <div
                class="mdl-cell mdl-cell--2-col mdl-cell--10-offset mdl-cell--12-col-tablet mdl-cell--12-col-phone"
              >
                <ActionButton
                  custom-class="cdlButton"
                  :loading="isExporting"
                  :disabled="!viewLoader"
                  @click="exportCsvVCloud"
                >
                  <img src="@/assets/img/download.png" alt="icon" />
                  {{ $t("users.downLoadCSV") }}
                </ActionButton>
              </div>
            </div>
            <!-- END FILTERS VCloud -->

            <div class="mdl-grid">
              <div class="mdl-cell mdl-cell--12-col">
                <br />
                <table class="cloud-report-table">
                  <thead v-if="!this.$IsMobile()">
                    <tr>
                      <th class="col-date">
                        {{ $t("reports.vcloud.col.date") }}
                      </th>
                      <th class="col-hours">
                        {{ $t("reports.vcloud.col.cpuNumber") }}
                      </th>
                      <th class="col-hours">
                        {{ $t("reports.vcloud.col.cpuUsage") }}
                      </th>
                      <th class="col-pph">
                        {{ $t("reports.vcloud.col.cpuPrice") }}
                      </th>
                      <th class="col-hours">
                        {{ $t("reports.vcloud.col.memoryUsage") }}
                      </th>
                      <th class="col-pph">
                        {{ $t("reports.vcloud.col.memoryPrice") }}
                      </th>
                      <th class="col-hours">
                        {{ $t("reports.vcloud.col.storageUsage") }}
                      </th>
                      <th class="col-pph">
                        {{ $t("reports.vcloud.col.storagePrice") }}
                      </th>
                      <th class="col-hours">
                        {{ $t("reports.vcloud.col.templateUsed") }}
                      </th>
                      <th class="col-pph">
                        {{ $t("reports.vcloud.col.templatePrice") }}
                      </th>
                      <th class="col-charge">
                        {{ $t("reports.vcloud.col.total") }}
                      </th>
                      <th class="col-details">
                        {{ $t("reports.vcloud.col.details") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    v-if="
                      !this.$IsMobile() && vViewLoader && vPagedItems.length > 0
                    "
                  >
                    <tr
                      v-for="(item, keyItem) in vPagedItems"
                      :key="keyItem"
                      :class="{ odd: keyItem % 2 }"
                    >
                      <td class="col-date">{{ item.date }}</td>
                      <td class="col-hours">
                        {{ item.cpu ? item.cpu.tot_vcpu_count : "" }}
                      </td>
                      <td class="col-hours">
                        {{ item.cpu ? item.cpu.usage : "" }}
                      </td>
                      <td class="col-pph">
                        {{ item.cpu ? item.cpu.price : "" }}
                      </td>
                      <td class="col-hours">
                        {{ item.memory ? item.memory.usage : "" }}
                      </td>
                      <td class="col-pph">
                        {{ item.memory ? item.memory.price : "" }}
                      </td>
                      <td class="col-hours">
                        {{ item.storage ? item.storage.usage : "" }}
                      </td>
                      <td class="col-pph">
                        {{ item.storage ? item.storage.price : "" }}
                      </td>
                      <td class="col-hours">
                        {{ item.metadata ? item.metadata.usage : "" }}
                      </td>
                      <td class="col-pph">
                        {{ item.metadata ? item.metadata.price : "" }}
                      </td>
                      <td class="col-charge">{{ item.total }}</td>
                      <td class="col-details">
                        <span
                          class="deleteOrder"
                          style="float: left"
                          @click="goToVcloudDetails(item)"
                          >{{ $t("reports.vcloud.col.details") }}</span
                        >
                      </td>
                    </tr>
                  </tbody>

                  <tbody
                    v-else-if="
                      this.$IsMobile() && vViewLoader && vPagedItems.length > 0
                    "
                  >
                    <tr
                      v-for="(item, keyItem) in vPagedItems"
                      :key="keyItem"
                      :class="{ odd: keyItem % 2 }"
                    >
                      <td>
                        <div>
                          <strong>{{ $t("reports.vcloud.col.date") }}</strong>
                        </div>
                        <div>{{ item.date }}</div>
                        <br />
                        <div>
                          <strong>{{
                            $t("reports.vcloud.col.cpuNumber")
                          }}</strong>
                        </div>
                        <div>{{ item.cpu ? item.cpu.tot_vcpu_count : "" }}</div>
                        <br />
                        <div>
                          <strong>{{
                            $t("reports.vcloud.col.cpuPrice")
                          }}</strong>
                        </div>
                        <div>{{ item.cpu ? item.cpu.price : "" }}</div>
                        <br />
                        <div>
                          <strong>{{
                            $t("reports.vcloud.col.memoryUsage")
                          }}</strong>
                        </div>
                        <div>{{ item.memory ? item.memory.usage : "" }}</div>
                        <br />
                        <div>
                          <strong>{{
                            $t("reports.vcloud.col.memoryPrice")
                          }}</strong>
                        </div>
                        <div>{{ item.memory ? item.memory.price : "" }}</div>
                        <br />
                        <div>
                          <strong>{{
                            $t("reports.vcloud.col.storageUsage")
                          }}</strong>
                        </div>
                        <div>{{ item.storage ? item.storage.usage : "" }}</div>
                        <br />
                        <div>
                          <strong>{{
                            $t("reports.vcloud.col.storagePrice")
                          }}</strong>
                        </div>
                        <div>{{ item.storage ? item.storage.price : "" }}</div>
                        <br />
                        <div>
                          <strong>{{
                            $t("reports.vcloud.col.templateUsed")
                          }}</strong>
                        </div>
                        <div>
                          {{ item.metadata ? item.metadata.usage : "" }}
                        </div>
                        <br />
                        <div>
                          <strong>{{
                            $t("reports.vcloud.col.templatePrice")
                          }}</strong>
                        </div>
                        <div>
                          {{ item.metadata ? item.metadata.price : "" }}
                        </div>
                        <br />
                        <div>
                          <strong>{{ $t("reports.vcloud.col.total") }}</strong>
                        </div>
                        <div>{{ item.total }}</div>
                        <br />
                        <div>
                          <strong>{{
                            $t("reports.vcloud.col.details")
                          }}</strong>
                        </div>
                        <div>
                          <span
                            class="deleteOrder"
                            @click="goToVcloudDetails(item)"
                            >{{ $t("reports.vcloud.col.details") }}</span
                          >
                        </div>
                      </td>
                    </tr>
                  </tbody>

                  <tbody v-if="vViewLoader && vPagedItems.length === 0">
                    <tr>
                      <td colspan="11">
                        <span class="noTickets">{{
                          $t("reports.noResult")
                        }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <Paginator
                  v-if="vViewLoader && vTotalItems > 0"
                  :total-page="vPaginatedItems"
                  :current-page="vCurrentPage"
                  :itemsPerPage="vItemsPerPage"
                  @prev-page="vBeforePage"
                  @next-page="vNextPage"
                  @change-page="vChangePage"
                />
                <div>
                  <MyLoading :viewLoader="vViewLoader" type="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyBanner from "@/components/MyBanner.vue";

import MyHeaderPage from "@/components/MyHeaderPage.vue";
import "@/assets/scss/TicketsList.scss";
import moment from "moment";
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import Paginator from "@/components/Paginator.vue";
import ReportTable from "@/components/Reports/ReportTable.vue";
import { exportCsvReport } from '@/services/CSVExportService.js'
import DownloadBinaryFile from '@/services/FileService'
import ActionButton from '@/components/Primitives/Buttons/ActionButton.vue'
export default {
  name: "CReportCloud",
  components: {
    MyBanner,
    MyHeaderPage,
    Paginator,
    ReportTable,
    ActionButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations() {
    return {
      dateFrom: { required },
      dateTo: { required },
    };
  },
  data() {
    return {
      viewLoader: false,
      selectedProject: "",
      items: [],
      itemFilter: [],
      // Add these for pagination
      currentPage: 1,
      // perPage: 10,
      paginatedItems: 0,
      totalItems: 0,

      // For the CSV export
      isExporting: false,

      // For project names from dedicated endpoint
      projectsList: [],
      dateFrom: moment().subtract(6, "months").format("DD-MM-YYYY"),
      dateTo: moment().format("DD-MM-YYYY"),
      he: {
        Accept: "application/json",
        Authorization: "Bearer " + this.$keycloak.idToken,
      },
      searchString: "",

      // VCloud tab states
      vViewLoader: false,
      vSelectedProject: "",
      vItems: [],
      vProjectsList: [],
      // Use ISO format so HTML date inputs are pre-filled and match sent params
      vDateFrom: moment().subtract(6, "months").format("YYYY-MM-DD"),
      vDateTo: moment().format("YYYY-MM-DD"),
      vSearchString: "",
      // VCloud pagination state
      vCurrentPage: 1,
      vItemsPerPage: 0,
      vTotalItems: 0,
      vPaginatedItems: 0,
    };
  },
  computed: {
    uniqueProjects() {
      // Use the dedicated projects list if available, otherwise fall back to extracting from items
      return this.projectsList.length > 0
        ? this.projectsList
        : [...new Set(this.items.map((item) => item.project_name))];
    },
    // VCloud computed helpers
    vUniqueProjects() {
      return this.vProjectsList.length > 0 ? this.vProjectsList : [];
    },
    totalPages() {
      return Math.ceil(this.itemFilter.length / this.itemsPerPage);
    },
    pagedItems() {
      return this.items || [];
    },
    vPagedItems() {
      return this.vItems || [];
    },
  },

  methods: {
    setTab(tab) {
      if (tab == 1) {
        try {
          document
            .getElementsByClassName("tabTwo")[0]
            .classList.remove("is-active");
          document
            .getElementsByClassName("tabTwo")[1]
            .classList.remove("is-active");
          document
            .getElementsByClassName("tabOne")[0]
            .classList.add("is-active");
          document
            .getElementsByClassName("tabOne")[1]
            .classList.add("is-active");
        } catch (e) {
          // elements not found; safe to ignore
        }
      } else {
        try {
          document
            .getElementsByClassName("tabTwo")[0]
            .classList.add("is-active");
          document
            .getElementsByClassName("tabTwo")[1]
            .classList.add("is-active");
          document
            .getElementsByClassName("tabOne")[0]
            .classList.remove("is-active");
          document
            .getElementsByClassName("tabOne")[1]
            .classList.remove("is-active");
        } catch (e) {
          // elements not found; safe to ignore
        }
        // Fetch vcloud data on switch
        if (!this.vViewLoader || this.vItems.length === 0) {
          this.getVcloudProjectsList();
          this.getVcloudList();
        }
      }
    },
    // New method to fetch project names from dedicated endpoint
    getProjectsList() {
      this.axios
        .get(
          window.VUE_APP_MISTRA_URL +
            "front/v1/report-cloud-project-names",
          { headers: this.he }
        )
        .then((response) => {
          if (response.data && response.data.project_names) {
            const normalizedList = Array.isArray(response.data.project_names)
              ? response.data.project_names
                  .map((entry) =>
                    entry && typeof entry === "object" ? entry.name : entry
                  )
                  .filter((name) => !!name)
              : [];
            this.projectsList = normalizedList;

            if (
              this.selectedProject &&
              !normalizedList.includes(this.selectedProject)
            ) {
              this.selectedProject = "";
            }
          } else {
            console.error(
              "Project names not found in response:",
              response.data
            );
            this.projectsList = [];
            this.selectedProject = "";
          }
        })
        .catch((error) => {
          console.error("Error fetching project names:", error);
          this.projectsList = [];
          this.selectedProject = "";
        });
    },

    handleDateChange() {
      this.currentPage = 1;
      this.getList();
    },

    getList() {
      if (!this.v$.dateFrom.$invalid && !this.v$.dateTo.$invalid) {
        this.viewLoader = false;

        let par = "";
        if (this.itemsPerPage) {
          par += "&per_page=" + this.itemsPerPage;
        }

        // Add project_name parameter if a project is selected
        if (this.selectedProject) {
          par += "&project_name=" + this.selectedProject;
        }

        // Add search parameter if exists
        if (this.searchString && this.searchString.trim() !== "") {
          par += "&search=" + this.searchString;
        }

        this.axios
          .get(
            window.VUE_APP_MISTRA_URL +
              "front/v1/report-cloud/?from=" +
              this.dateFrom +
              "&to=" +
              this.dateTo +
              "&page=" +
              this.currentPage +
              par,
            { headers: this.he }
          )
          .then((response) => {
            // Handle the new pagination structure
            this.items = response.data.data;
            this.currentPage = response.data.current_page;
            this.itemsPerPage = response.data.per_page;
            this.totalItems = response.data.total;
            this.paginatedItems = Math.ceil(
              this.totalItems / response.data.per_page
            );

            // Extract unique projects for the filter dropdown
            if (this.items && this.items.length > 0) {
              this.uniqueProjects = [
                ...new Set(
                  this.items
                    .filter((item) => item.project_name)
                    .map((item) => item.project_name)
                ),
              ];
            }

            this.viewLoader = true;
          })
          .catch((error) => {
            console.error("Error fetching report data:", error);
            this.viewLoader = true;
          });
      }
    },

    // Add this method for CSV export
    async exportCsvCloud() {
      this.isExporting = true;
      const params = {
        from: this.dateFrom,
        to: this.dateTo,
        csv: true,
        ...(this.searchString?.trim() && { search: this.searchString }),
        ...(this.selectedProject && { project_name: this.selectedProject }),
      };

      try {
        const { blob, headers } = await exportCsvReport(
          window.VUE_APP_MISTRA_URL + "front/v1/report-cloud/",
          this.$keycloak.idToken,
          params
        );
        const match = headers["content-disposition"]?.match(/filename="(.+)"/);
        const filename = match?.[1] ?? "cloud_report.csv";
        DownloadBinaryFile.downloadBlob(blob, filename);
      } catch (error) {
        console.error(error);
      } finally {
        this.isExporting = false;
      }
    },
    async exportCsvVCloud() {
      this.isExporting = true;
   
      const params = {
        infrastructure : 'vcloud',
        from: this.dateFrom,
        to: this.dateTo,
        csv: true,
        ...(this.searchString?.trim() && { search: this.searchString }),
        ...(this.vSelectedProject && { project_name: this.vSelectedProject }),
      };

      try {
        const { blob, headers } = await exportCsvReport(
          window.VUE_APP_MISTRA_URL + "front/v1/report-cloud/",
          this.$keycloak.idToken,
          params
        );
        const match = headers["content-disposition"]?.match(/filename="(.+)"/);
        const filename = match?.[1] ?? "cloud_report.csv";
        DownloadBinaryFile.downloadBlob(blob, filename);
      } catch (error) {
        console.error(error);
      } finally {
        this.isExporting = false;
      }
    },
    // Methods to handle pagination for the Paginator component
    changePage(page) {
      this.currentPage = page;
      this.getList();
    },

    beforePage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getList();
      }
    },

    nextPage() {
      if (this.currentPage < Math.ceil(this.totalItems / this.itemsPerPage)) {
        this.currentPage++;
        this.getList();
      }
    },

    // VCloud pagination handlers
    vChangePage(page) {
      this.vCurrentPage = page;
      this.getVcloudList();
    },
    vBeforePage() {
      if (this.vCurrentPage > 1) {
        this.vCurrentPage--;
        this.getVcloudList();
      }
    },
    vNextPage() {
      if (
        this.vCurrentPage < Math.ceil(this.vTotalItems / this.vItemsPerPage)
      ) {
        this.vCurrentPage++;
        this.getVcloudList();
      }
    },

    // Update your existing searchByString method
    searchByString() {
      // Reset pagination when searching
      this.currentPage = 1;
      this.getList();
    },

    // Update your existing filterByProject method
    filterByProject() {
      // Reset pagination when filtering
      this.currentPage = 1;
      this.getList();
    },
    // 🚀 New Clearly corrected COMBINED FILTERING METHOD:
    applyFilters() {
      let filteredItems = [...this.items];

      // Filter by project explicitly:
      if (this.selectedProject) {
        filteredItems = filteredItems.filter(
          (item) => item.project_name === this.selectedProject
        );
      }

      // Now also apply search filter explicitly:
      if (this.searchString && this.searchString.trim()) {
        const query = this.searchString.trim().toLowerCase();
        filteredItems = filteredItems.filter((item) =>
          Object.values(item).some(
            (val) => val && val.toString().toLowerCase().includes(query)
          )
        );
      }

      this.itemFilter = filteredItems; // final filtered result
    },

    goToVcloudDetails(item) {
      // Determine date to pass (normalize to YYYY-MM-DD if possible)
      const raw = item && item.date ? item.date : this.vDateFrom;
      let date = raw;
      try {
        const formats = ["DD/MM/YYYY", "DD-MM-YYYY", "YYYY-MM-DD"];
        let mm = null;
        for (const f of formats) {
          const t = moment(raw, f, true);
          if (t.isValid()) {
            mm = t;
            break;
          }
        }
        if (!mm) mm = moment(raw);
        if (mm && mm.isValid()) date = mm.format("YYYY-MM-DD");
      } catch (e) {
        // fallback keep raw
      }
      // Keep query param backward-compatible: pass the project name (string)
      let projectName = "";
      if (this.vSelectedProject) {
        projectName = this.vSelectedProject;
      } else if (this.vProjectsList && this.vProjectsList.length > 0) {
        const first = this.vProjectsList[0];
        projectName = first && typeof first === "object" ? first.name : first;
      }
      this.$router.push({
        name: "VCloudDetail",
        query: { date, project_name: projectName },
      });
    },

    // VCloud specific methods
    getVcloudProjectsList() {
      const base = window.VUE_APP_MISTRA_URL;
      const url = `${base}front/v1/report-cloud-project-names?infrastructure=vcloud&from=${this.vDateFrom}&to=${this.vDateTo}`;
      this.axios
        .get(url, { headers: this.he })
        .then((response) => {
          if (response.data && response.data.project_names) {
            this.vProjectsList = response.data.project_names;
            // Auto-select the first available project if none is selected or if the current selection is not in the new list
            const list = Array.isArray(this.vProjectsList)
              ? this.vProjectsList
              : [];
            const first = list.length > 0 ? list[0] : null;
            const firstName = first
              ? typeof first === "object" && first !== null
                ? first.name
                : first
              : "";
            const hasSelected = !!this.vSelectedProject;
            const selectionStillValid =
              hasSelected &&
              list.some(
                (p) =>
                  (typeof p === "object" && p !== null ? p.name : p) ===
                  this.vSelectedProject
              );
            if (!selectionStillValid) {
              this.vSelectedProject = firstName || "";
            }
          } else {
            this.vProjectsList = [];
            this.vSelectedProject = "";
          }
        })
        .catch((error) => {
          console.error("Error fetching VCloud project names:", error);
          this.vProjectsList = [];
        });
    },

    getVcloudList() {
      // No Vuelidate for vcloud dates; ensure they exist
      if (!this.vDateFrom || !this.vDateTo) return;
      this.vViewLoader = false;

      let par = `&infrastructure=vcloud`;
      if (this.vSelectedProject) {
        par += `&project_name=${encodeURIComponent(this.vSelectedProject)}`;
      }
      if (this.vSearchString && this.vSearchString.trim() !== "") {
        par += `&search=${encodeURIComponent(this.vSearchString.trim())}`;
      }

      // Append pagination params if available
      if (this.vItemsPerPage) {
        par += `&per_page=${this.vItemsPerPage}`;
      }
      if (this.vCurrentPage) {
        par += `&page=${this.vCurrentPage}`;
      }

      const url =
        window.VUE_APP_MISTRA_URL +
        `front/v1/report-cloud/?from=${this.vDateFrom}&to=${this.vDateTo}${par}`;

      this.axios
        .get(url, { headers: this.he })
        .then((response) => {
          // Expected paginated shape similar to Cloud tab
          if (response && response.data) {
            if (Array.isArray(response.data)) {
              // Fallback: API returns array directly
              this.vItems = response.data;
              this.vTotalItems = this.vItems.length;
              this.vItemsPerPage = this.vItems.length;
              this.vPaginatedItems = 1;
              this.vCurrentPage = 1;
            } else {
              // Attempt to read pagination metadata
              const dataArr = Array.isArray(response.data.data)
                ? response.data.data
                : [];
              this.vItems = dataArr;
              if (response.data.total !== undefined) {
                this.vTotalItems = response.data.total || 0;
              }
              if (response.data.per_page !== undefined) {
                this.vItemsPerPage =
                  response.data.per_page || this.vItems.length || 0;
              }
              if (response.data.current_page !== undefined) {
                this.vCurrentPage = response.data.current_page || 1;
              }
              // Compute total pages
              if (this.vItemsPerPage && this.vTotalItems) {
                this.vPaginatedItems = Math.ceil(
                  this.vTotalItems / this.vItemsPerPage
                );
              } else {
                this.vPaginatedItems = this.vItems.length > 0 ? 1 : 0;
              }
            }
          } else {
            this.vItems = [];
            this.vTotalItems = 0;
            this.vPaginatedItems = 0;
          }
          this.vViewLoader = true;
        })
        .catch((error) => {
          console.error("Error fetching VCloud report data:", error);
          this.vViewLoader = true;
        });
    },

    exportVcloudCsv() {
      // Build params
      let par = `&infrastructure=vcloud`;
      if (this.vSelectedProject) {
        par += `&project_name=${encodeURIComponent(this.vSelectedProject)}`;
      }
      if (this.vSearchString && this.vSearchString.trim() !== "") {
        par += `&search=${encodeURIComponent(this.vSearchString.trim())}`;
      }

      const header = {
        Authorization: "Bearer " + this.$keycloak.idToken,
        Accept: "text/csv",
      };

      const url =
        window.VUE_APP_MISTRA_URL +
        `front/v1/report-cloud/?from=${this.vDateFrom}&to=${this.vDateTo}&csv=true${par}`;

      this.axios
        .get(url, { headers: header, responseType: "blob" })
        .then((response) => {
          const blob =
            response.data instanceof Blob
              ? response.data
              : new Blob([response.data]);
          const urlBlob = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = urlBlob;

          const contentDisposition =
            response.headers &&
            (response.headers["content-disposition"] ||
              response.headers["Content-Disposition"]);
          let filename = "vcloud_report.csv";
          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="(.+)"/);
            if (filenameMatch && filenameMatch.length === 2) {
              filename = filenameMatch[1];
            }
          }
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => {
          console.error("Error downloading VCloud CSV:", error);
        });
    },

    filterByVProject() {
      this.vCurrentPage = 1;
      this.getVcloudList();
    },
    searchVByString() {
      this.vCurrentPage = 1;
      this.getVcloudList();
    },
  },
  watch: {
    // Watch if 'items' get updated, reapply filter when needed
    items() {
      // this.filterByProject();
    },
  },

  mounted() {
    // Fetch project names from dedicated endpoint
    this.getProjectsList();
    // Fetch report data
    this.getList();
  },
};
</script>
<style lang="scss" src="@/assets/scss/ReportCloud.scss"></style>
